exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b96626e6","scoped":true,"hasInlineConfig":false}!./~/px2rem-loader?{"remUnit":198,"baseDpr":1}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/libs/dictSelect/Dict.vue
// module id = 1067
// module chunks = 7